require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./build-a-basic-flutter-app.json") })
        }
      }, "path---build-a-basic-flutter-app");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---build-a-basic-flutter-app!./.cache/json/build-a-basic-flutter-app.json
// module id = 370
// module chunks = 231608221292675